import { createSelector } from 'reselect';
import { ITenderGroupsState, ITenderGroupItem } from './types';

export const selectTenderGroups = (state: ITenderGroupsState) => state.tenderGroups;

export const selectIndexedTenders = createSelector(selectTenderGroups, (tenderGroups) =>
  tenderGroups.reduce(
    (indexed: { [key: string]: ITenderGroupItem }, tenderGroup: ITenderGroupItem) => {
      if (tenderGroup.groupId) {
        indexed[tenderGroup.groupId] = tenderGroup;
      }
      return indexed;
    },
    {}
  )
);
